<template lang="pug">
.vprContentsModalComponent
  .title Библиографический список
  .info
    .subject(v-if="vpr.subject?.label")
      span.label Предмет:
      span.value {{ vpr.subject.label }}
    .level(v-if="vpr.levelText")
      span.label Класс:
      span.value {{ vpr.levelText }}
    .authors(v-if="vpr.author")
      span.label Авторы:
      span.value {{ vpr.author }}
    .publisher(v-if="vpr.publisher")
      span.label Издательство:
      span.value {{ vpr.publisher }}
    .created(v-if="vpr.createdAt")
      span.label Загружено:
      span.value {{ vpr.createdAt?.format('DD MMMM YYYY') + ' г.' ?? '' }}

  .copyright(
    v-if="vpr.copyright"
    v-html="vpr.copyright"
  )
</template>

<script>
import Vpr from '@/models/Vpr'
export default {
  props: {
    vpr: {
      type: Vpr,
      required: true
    }
  }
}
</script>

<style lang="sass" scoped>
.vprContentsModalComponent
  max-width: $padWidth
  display: flex
  flex-flow: column
  gap: 5*$u
  justify-content: center

  > .title
    width: 90%
    @include font('h2')

  > .info
    .label
      @include font('t16-demibold')
      margin-right: 2*$u

    .value
      @include font('t16-regular')

  > .copyright
    &:deep
      @include font('t16-demibold')
      > p
      > ol
        list-style-type: decimal
        padding-left: 5*$u
        > li
          margin-top: 2*$u
          > p
          > ul
            > li
              @include font('t16-regular')
              margin-top: $u
              &:first-child
                margin-top: 0
</style>
